<header class="header">
  <div class="header__inner">
    <div class="logo">
      <img src="assets/logo.png" alt="Explora Vizula" />
    </div>

    <button class="menu-btn" type="button" (click)="menuClick.emit()">
      <img src="assets/menu.png" alt="Menu" />
    </button>
  </div>
</header>
